import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import * as s from './Button.module.scss'

const Button = ({ title, className, variant, size, onClick }) => {
  return (
    <button
      type="button"
      className={cn(s.button, className, s[variant], s[size])}
      onClick={onClick}
    >
      {title}
    </button>
  )
}

export default Button

Button.defaultProps = {
  title: '',
  className: '',
  variant: 'filled',
  size: 'md',
  onClick: () => {},
}

Button.propTypes = {
  //   children: PropTypes.node.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['filled', 'outlined']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  onClick: PropTypes.func,
}
